{ Card, CardContent, CellWithTitle } = ReactComponents
EtdActions = require 'actions/etd_actions'
EtdEditor = require 'components/etd/etd_editor'
Translation = require 'components/mixins/translation'

AdditionalConsideration = createReactClass
  displayName: 'AdditionalConsiderationComponent'
  mixins: [Translation('es:recommendations.table')]
  propTypes:
    placeholder: PropTypes.string

  getDefaultProps: ->
    placeholder: null

  getContent: ->
    { additionalConsiderations, isConsensus } = @props

    if isConsensus
      additionalConsiderations.get('contentConsensus') or additionalConsiderations.get('content')
    else
      additionalConsiderations.get('content')

  onEditClick: ->
    return if @props.readOnly
    if not @props.editable and @props.onEditClick
      @props.onEditClick()

  render: ->
    {
      cellId
      colSpan
      editable
      highlighted
      isConsensus
      onFocus
      placeholder
      readOnly
      renderMode
      rowSpan
    } = @props
    cellClass = classNames 'additional-considerations', 'highlighted': highlighted
    editable = if (renderMode is 'printout' or readOnly) then false else editable
    cardClassess = classNames 'ep-card-with-etd-editor', 'readOnly': readOnly

    <CellWithTitle
      cellTitle={@i18n 'additional_considerations' unless renderMode is 'printout'}
      className={cellClass}
      colSpan={colSpan}
      rowSpan={rowSpan}
    >
      <div onClick={@onEditClick}>
        <Card className={cardClassess}>
          <CardContent>
            <EtdEditor
              cellId={cellId}
              content={@getContent()}
              editable={editable}
              isConsensus={isConsensus}
              noInsertOption
              onFocus={onFocus}
              onSaveContent={EtdActions.updateEditorContent}
              placeholder={placeholder}
              renderMode={renderMode}
            />
          </CardContent>
        </Card>
      </div>
    </CellWithTitle>

module.exports = AdditionalConsideration
